// src/services/utilities/cartUtils.js

/**
 * Formats and trims the location data from the order state.
 * @param {Object} order - The current order state object.
 * @returns {Object} Formatted location object.
 */
export const formatLocationData = (order) => {
  return {
    address: order.address?.trim() || '',
    address_2: order.address_2?.trim() || '',
    city: order.city || '',
    state: order.state || '',
    postal_code: order.postal_code?.trim() || '',
    country: order.country || '',
  }
}

/**
 * Formats and trims the contact data from the order state.
 * @param {Object} order - The current order state object.
 * @returns {Object} Formatted contact object.
 */
export const formatContactData = (order) => {
  return {
    fname: order.customerFName?.trim() || '',
    lname: order.customerLName?.trim() || '',
    email: order.customerEmail?.trim() || '',
    phone: order.customerPhone?.trim() || '',
  }
}